@if (form(); as formGroup) {
  <form class="flex w-full flex-col gap-8" [formGroup]="formGroup">
    <div>
      <p class="font-bold">Is this claim for a work related injury? *</p>
      <mat-radio-group
        class="mb-2 flex flex-col"
        formControlName="workInjury"
        required
      >
        @for (option of booleanOptions; track option.code) {
          <mat-radio-button class="mr-4" [value]="option.label">
            {{ booleanDisplay[option.code] }}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (formGroup.workInjuryRequiredError) {
        <mat-error>This field is required</mat-error>
      }
      <pr-information-box>
        Work related injury: at the physical place of employment, while the
        employee is there for the purposes of work, during normal work hours
        (this includes a place that moves or a place that the client moves
        through) or while the employee is laking a break from work and remains
        on the work premises.
      </pr-information-box>
    </div>

    <div>
      <p class="font-bold">Is the patient in paid employment? *</p>
      <mat-radio-group
        class="mb-2 flex flex-col"
        formControlName="inPaidEmployment"
        required
        (change)="inPaidEmploymentSelected($event, formGroup)"
      >
        @for (option of booleanOptions; track option.code) {
          <mat-radio-button class="mr-4" [value]="option.label">
            {{ booleanDisplay[option.code] }}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (formGroup.inPaidEmploymentRequiredError) {
        <mat-error>This field is required</mat-error>
      }
    </div>

    <div>
      <mat-form-field class="w-full">
        <mat-label>Patient occupation</mat-label>
        <input
          type="text"
          matInput
          placeholder="Type to search..."
          [formControl]="occupationSearchCtrl"
          [matAutocomplete]="occupationAutocomplete"
        />
        <mat-autocomplete
          #occupationAutocomplete="matAutocomplete"
          autoActiveFirstOption
          [displayWith]="displayFn"
          (optionSelected)="occupationSelected($event, formGroup)"
        >
          @for (
            occupation of occupationSearch.results$ | async;
            track occupation.code + occupation.displayName
          ) {
            <mat-option [value]="occupation">
              <span>{{ occupation.displayName }}</span>
            </mat-option>
          }
        </mat-autocomplete>
        <mat-hint>Start typing to find occupation</mat-hint>
        @if (formGroup.occupationCodeRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
    </div>

    @if (formGroup.isInPaidEmployment) {
      <mat-form-field class="w-full">
        <mat-label>What level of activity is involved at work?</mat-label>
        <mat-select formControlName="workTypeCode">
          @for (option of workTypeOptions; track option.code) {
            <mat-option [value]="option.code">{{ option.label }}</mat-option>
          }
        </mat-select>
        @if (formGroup.workTypeCodeRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Please select the nature of employment</mat-label>
        <mat-select formControlName="employmentStatusCode" required>
          @for (option of employmentStatusOptions; track option.code) {
            <mat-option [value]="option.code">{{ option.label }}</mat-option>
          }
        </mat-select>
        @if (formGroup.employmentStatusCodeRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>

      @if (formGroup.displayOtherEmployment) {
        <mat-form-field class="w-full">
          <mat-label>Other Employment</mat-label>
          <textarea
            matInput
            formControlName="otherEmployment"
            rows="3"
          ></textarea>
          <mat-hint>Provide any other employment information here</mat-hint>
          @if (formGroup.otherEmploymentRequiredError) {
            <mat-error>This field is required</mat-error>
          }
        </mat-form-field>
      }

      @if (formGroup.displayEmployer) {
        <div class="mb-2">
          <h2 class="!font-medium">Employer name and address</h2>
          <div formGroupName="employer">
            <mat-form-field class="w-full">
              <mat-label>Employer Name</mat-label>
              <input matInput formControlName="employerName" />
              @if (formGroup.employer.employerNameRequiredError) {
                <mat-error>This field is required</mat-error>
              }
            </mat-form-field>

            <div class="mt-4" formGroupName="address">
              <pr-address-input
                label="Search"
                [hideManualEntry]="true"
                [formControl]="addressCtrl"
              />

              <mat-form-field class="w-full">
                <mat-label>Address Line 1</mat-label>
                <input matInput formControlName="line1" required />
                @if (formGroup.employer.address.line1RequiredError) {
                  <mat-error>This field is required</mat-error>
                }
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Address Line 2</mat-label>
                <input matInput formControlName="line2" />
                <mat-hint align="end">Optional</mat-hint>
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Suburb</mat-label>
                <input matInput formControlName="suburb" />
                <mat-hint align="end">Optional</mat-hint>
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>City</mat-label>
                <input matInput formControlName="city" required />
                @if (formGroup.employer.address.cityRequiredError) {
                  <mat-error>This field is required</mat-error>
                }
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Post Code</mat-label>
                <input matInput formControlName="postCode" required />
                @if (formGroup.employer.address.postCodeRequiredError) {
                  <mat-error>This field is required</mat-error>
                }
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Country</mat-label>
                <input
                  matInput
                  formControlName="country"
                  required
                  value="New Zealand"
                />
                @if (formGroup.employer.address.countryRequiredError) {
                  <mat-error>This field is required</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    }
  </form>
}
